<template>
  <div v-if="banner?.pictures && screenWidth >= 768" class="sign-banner">
    <DefPicture :result="banner?.pictures" />
  </div>
</template>

<script lang="ts" setup>
import useScreenWidth from '@use/useScreenWidth';
// import { IPictures } from '@/interfaces/IPicture';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import { computed, onBeforeMount } from 'vue';
import { useStore } from '@/store';

const screenWidth = useScreenWidth();

type TResult = 'register' | 'auth' | 'change_password';

const props = defineProps<{ result: TResult }>();

const { state } = useStore();

const signInBanners = computed(() => state.results?.signInBanners);

const banner = signInBanners.value?.find((el) => {
  if (el.signInTypeKeys.find((key) => key === props.result)) {
    return true;
  }

  return false;
});

onBeforeMount(() => {});

// const props = defineProps<{ result: IPictures }>();
</script>

<style lang="scss" scoped>
.sign-banner {
}
</style>
